import React from "react";
import { useTranslation } from 'react-i18next';
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGolang, faDocker } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

function Expertise() {
    const { t } = useTranslation();

    const backendSkills = (() => {
        const skills = t('expertise.backend.skills', { returnObjects: true });
        return Array.isArray(skills) ? skills : [];
    })();

    const devopsSkills = (() => {
        const skills = t('expertise.devops.skills', { returnObjects: true });
        return Array.isArray(skills) ? skills : [];
    })();
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>{t('expertise.title')}</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faGolang as any} size="3x"/>
                    <h3>{t('expertise.backend.title')}</h3>
                    <p>{t('expertise.backend.description')}</p>
                    <div className="flex-chips">
                        <span className="chip-title">{t('expertise.backend.techStack')}</span>
                        {backendSkills.map((skill: any, index: number) => (
                            <Chip key={index} className='chip' label={skill} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker as any} size="3x"/>
                    <h3>{t('expertise.devops.title')}</h3>
                    <p>{t('expertise.devops.description')}</p>
                    <div className="flex-chips">
                        <span className="chip-title">{t('expertise.devops.techStack')}</span>
                        {devopsSkills.map((skill: any, index: number) => (
                            <Chip key={index} className='chip' label={skill} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;